import React, { useState } from 'react'

interface SpoilerTextProps {
  children: string
  className?: string
}

const SpoilerText: React.FC<SpoilerTextProps> = ({ children, className = '' }) => {
  const [isRevealed, setIsRevealed] = useState(false)

  return (
    <span
      className={`inline-block px-1 rounded cursor-pointer transition-all duration-200 ${
        isRevealed 
          ? 'bg-transparent text-gray-300' 
          : 'bg-gray-600 text-transparent hover:bg-gray-500'
      } ${className}`}
      onClick={() => setIsRevealed(!isRevealed)}
      onMouseEnter={() => setIsRevealed(true)}
      onMouseLeave={() => setIsRevealed(false)}
    >
      {children}
    </span>
  )
}

export default SpoilerText 